<template>
  <section id="sectionFooter" class="footer-sections">
    <div class="container">
      <div class="row">
        <div class="col-md-4 footer-info">
          <span class="footer-head d-block">Contact us</span>
          <div class="footer-sub">
            <span><a href="mailto:info@kipsvirtual.com">info@kipsvirtual.com</a></span>
            <span><a href="tel:042111547775">(042) 111 547 775</a></span>
            <span><a href="https://goo.gl/maps/M24HR1tHXdEApySZ8" target="_blank"> 5/6, D-1 Khayaban-e-Firdousi, Johar
                Town Lahore, Pakistan</a></span>
          </div>
        </div>
        <div class="col-md-4 footer-info">
          <span class="footer-head d-block">Useful links</span>
          <div class="footer-sub">
            <router-link class="footer-links" to="/category">Enroll</router-link>
            <router-link class="footer-links" to="/popularPrograms">Popular Programs</router-link>
            <!-- <a class="footer-links" target="_blank" href="https://kips.edu.pk/blog/">Blogs</a> -->

            <router-link class="footer-links" to="/faq">FAQs</router-link>

            <router-link class="footer-links" to="/howitworks">How it works</router-link>
            <!-- <router-link class="footer-links" to="/faq">FAQs</router-link> -->
            <router-link class="footer-links" to="/privacy">Privacy</router-link>
            <router-link class="footer-links" to="/refund">Refund Policy</router-link>
            <router-link class="footer-links" to="/terms&conditions">Terms and Conditions</router-link>
          </div>
        </div>
        <div class="col-md-4 footer-info">
          <span class="footer-head d-block">Follow us</span>
          <div class="footer-sub">
            <span class="follow-us">Connect with us through social media to keep updated with important
              information.</span>
          </div>
          <div class="footer-icons">
            <a href="http://www.facebook.com/kipsvirtual" target="_blank"><i class="fab fa-facebook-f"></i></a>
            <a href="http://www.instagram.com/kipsvirtual" target="_blank1"><i class="fab fa-instagram"></i></a>
            <a href="https://www.youtube.com/@KIPSVirtual" target="_blank1"><i class="fab fa-youtube"></i></a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {};
</script>
